import { SearchAdapter } from '@empathy/search-adapter';
import { Redirection } from '@empathy/search-types';
import { container } from '../../../container';
import { DEPENDENCIES } from '../../../container/dependencies.const';
import { SEARCH_ACTIONS_KEYS } from '../search.const';
import { SearchAction, SearchContext } from '../search.interfaces';

export class RedirectionAction implements SearchAction {
  actions = {
    [SEARCH_ACTIONS_KEYS.redirect]: ({ state }: SearchContext, redirection: Redirection): any => {
      const adapter = container.get<SearchAdapter>(DEPENDENCIES.Adapter);
      adapter.track(redirection.tagging.click);
      window.location.href = redirection.url;
    }
  };
}
